import { OutlineReq, Paper } from 'packages/sdks-next/growp'

/**
 * 格式化 outlines
 *
 * @param outlines - 外层大纲
 * @returns outlines
 */
export const formatOutlines = (
  outlines: Omit<OutlineReq, 'treeNodeId' | 'treeNodePid'>[]
): OutlineReq[] => {
  return outlines.map((outline, index) => {
    return { ...outline, treeNodeId: index + 1, treeNodePid: 0 }
  })
}

export const getSelectedPaperInfo = (originData: Paper[]) => {
  if (originData.length) {
    return {
      ...originData[0],
      originId: originData[0].originId || originData[0].id,
    }
  }
  return {
    name: '-',
    blockCount: 0,
    originId: 0,
  }
}
